export default __webpack_public_path__ + "static/media/CtA-sales.51aff838.png";